import PublicLayout from '../components/layouts/PublicLayout';
import { Container } from 'reactstrap';
import { useState, useEffect } from 'react';
import { Accordion } from 'react-bootstrap';
import Link from 'next/link';
import axios from 'axios';
import Head from 'next/head';
import ReactPaginate from 'react-paginate';

import { useRouter } from 'next/router'

import { ListInlineItem } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function ToprowFaq({data}) {
    const router = useRouter();
 	
    const [loading, setLoading] = useState(false); 
 	const [categories, setCategories] = useState([]);
 	 const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);

	useEffect(() => {
		if(data) {
            let pagination = data.meta.pagination;
            setPageCount(pagination.total_pages);
            setCurrentPage(pagination.current_page);
          	setCategories(data.data);
        }

	}, []);
	useEffect(() => {
		getRequestApi()
	}, [currentPage])

	const getRequestApi = () => {
		console.log(currentPage)
		setLoading(true);
		axios.get(process.env.NEXT_PUBLIC_API_URL+'all_categories',{
			params:{
				page: currentPage,
				limit: 10,
			}
		}).then((response) => {
            setLoading(false);
            let pagination = response.data.meta.pagination;
            setPageCount(pagination.total_pages);
          	setCategories(response.data.data);

		},(error) => {
            setLoading(false);
		});
	}

	const subCategoriesData = (slug, subCategories) => {
		return subCategories.map((res, i) => {
				return (
					<>
						<li className="accordian_li">
							<a href={"/agencies/"+slug +'/'+res.slug + '/'} target="_blank" rel="noreferrer">{res.name}</a>
						</li>
					</>
				)
			})
	}

	const DataTable = () => {
		if(categories.length) {
			return categories.map((res, i) => {
				return (
					<>
					<Accordion.Item eventKey={i}>
						<Accordion.Header>
							<a href={process.env.NEXT_PUBLIC_APP_URL + "/agencies/"+res.attributes.slug + '/'}
							target="_blank" rel="noreferrer"
							style={{'color': '#0052c3', 'fontWeight': 700}}
							>{res.attributes.name}</a>
						</Accordion.Header>
						<Accordion.Body>
					
						<ul className="sitemap_listing">
							{subCategoriesData(res.attributes.slug, res.attributes.sub_categories)}
						</ul>
					
						</Accordion.Body>
					</Accordion.Item>
					</>
				)
			})
		}
	}

	const skeletonLoader = () => {
		return (
			<div className="faq_placeholder">
				<ListInlineItem className='col-md-12'>
					<div className="skeleton_box2">
						<div className="skeleton_lines">
							<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
								<Skeleton />
								<Skeleton />
							</SkeletonTheme>
						</div>
					</div>
				</ListInlineItem>
				<ListInlineItem className='col-md-12'>
					<div className="skeleton_box2">
						<div className="skeleton_lines">
							<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
								<Skeleton />
								<Skeleton />
							</SkeletonTheme>
						</div>
					</div>
				</ListInlineItem>
				<ListInlineItem className='col-md-12'>
					<div className="skeleton_box2">
						<div className="skeleton_lines">
							<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
								<Skeleton />
								<Skeleton />
							</SkeletonTheme>
						</div>
					</div>
				</ListInlineItem>
				<ListInlineItem className='col-md-12'>
					<div className="skeleton_box2">
						<div className="skeleton_lines">
							<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
								<Skeleton />
								<Skeleton />
							</SkeletonTheme>
						</div>
					</div>
				</ListInlineItem>
				<ListInlineItem className='col-md-12'>
					<div className="skeleton_box2">
						<div className="skeleton_lines">
							<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
								<Skeleton />
								<Skeleton />
							</SkeletonTheme>
						</div>
					</div>
				</ListInlineItem>
				<ListInlineItem className='col-md-12'>
					<div className="skeleton_box2">
						<div className="skeleton_lines">
							<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
								<Skeleton />
								<Skeleton />
							</SkeletonTheme>
						</div>
					</div>
				</ListInlineItem>
				<ListInlineItem className='col-md-12'>
					<div className="skeleton_box2">
						<div className="skeleton_lines">
							<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
								<Skeleton />
								<Skeleton />
							</SkeletonTheme>
						</div>
					</div>
				</ListInlineItem>
			</div>
		);
	}
	return (
        <>
        	<Head>
				<title>Sitemap | Toprow.co</title>
				<link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
			</Head>
			<Container fluid="xl" style={{'minHeight': '400px', 'marginBottom': '57px'}}>
					<div id="spinner" className="spinner_req_review sitemap_loader" style={{ "display": loading ? "block" : "none"}}>
					<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
				</div>
				<div className="faq-sections padding-set faq_sitemap" >
       				 <h1 className="" style={{'marginBottom': '25px'}}>Sitemap</h1>
					{!categories.length && !loading ? 
						skeletonLoader() :
						<Accordion defaultActiveKey="0">
							{DataTable()}
						</Accordion>
					}
					
				</div>
				{!loading ? 
					<div className="custom-pagination-fr" style={{'display': pageCount > 1 ? '' : 'none'}}>
						<ReactPaginate
							breakLabel="..."
							nextLabel=">"
							marginPagesDisplayed={1}
							pageRangeDisplayed={1}
							pageCount={pageCount}
							previousLabel="<"
							nextLinkClassName="next"
							previousLinkClassName="prev"
							activePage={currentPage}
							forcePage={currentPage-1}
							onPageChange={(pageNumber) => setCurrentPage(pageNumber.selected+1) }
							renderOnZeroPageCount={1}
						/>
					</div>
					: ''}
			</Container>
        </>
	)
}


// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'all_categories?limit=10&page=1', { headers: {
            "Accept": "application/json" }
        });
        return { props: {
        	data: response.data,
          } }

    } catch (err) {
        const data = false;

        return { props: { meta } };
    }
}

ToprowFaq.Layout = PublicLayout;

export default ToprowFaq
